module.exports = __webpack_public_path__ + "static/faviconAbitareCo-a79a0b7c0583fd57595e10b367559076.png";